import 'typeface-roboto';
import React from 'react';
import ReactDOM from 'react-dom';
import ThemeProvider from '@bit/medicalwebexperts.mwe-ui.theme-provider';
import AuthenticationProvider from '@bit/medicalwebexperts.mwe-ui.auth-context';
import SnackbarProvider from '@bit/medicalwebexperts.mwe-ui.snackbar-context';
import Normalize from '@bit/medicalwebexperts.mwe-ui.normalize';

import App from './App';
import theme from './themes/preset';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import authClient from './services/authClient';

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <Normalize />
      <AuthenticationProvider client={authClient} storageKey="access">
        <SnackbarProvider>
          <App />
        </SnackbarProvider>
      </AuthenticationProvider>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
